<form fxFill [formGroup]="recurrenceFormGroup" (ngSubmit)="submit()">
  <div class="flex flex-col gap-4">
    <div class="flex flex-row gap-4">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ seperationCountLabel }}</mat-label>
        <input
          type="number"
          min="1"
          matInput
          formControlName="seperationCount"
        />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-select
          formControlName="customFrequencyType"
          (selectionChange)="updateMonthOptions($event)"
        >
          <mat-option
            *ngFor="let freq of frequencies; trackBy: trackByFrequency"
            [value]="freq.value"
          >
            {{ freq.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-content select=".time-selector"></ng-content>
    </div>

    <div
      *ngIf="recurrenceFormGroup.isWeekly()"
      class="flex flex-row flex-wrap"
      formGroupName="daysOfWeek"
    >
      <div class="flex w-1/4">
        <mat-checkbox formControlName="monday">Mon</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="tuesday">Tue</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="wednesday">Wed</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="thursday">Thu</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="friday">Fri</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="saturday">Sat</mat-checkbox>
      </div>
      <div class="flex w-1/4">
        <mat-checkbox formControlName="sunday">Sun</mat-checkbox>
      </div>
    </div>

    @if (recurrenceFormGroup.isMonthly()) {
      <mat-form-field subscriptSizing="dynamic">
        <mat-select formControlName="monthlyOption">
          <mat-option
            *ngFor="let option of monthOptions; trackBy: trackByMonth"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    }

    <div class="flex flex-col">
      <div class="font-bold text-black">Ends</div>
      <mat-radio-group class="flex flex-col gap-4" formControlName="endingType">
        <div class="flex flex-row items-center">
          <mat-radio-button class="w-36" value="never">Never</mat-radio-button>
        </div>

        <div class="flex flex-row items-center">
          <mat-radio-button class="w-36" value="on">On</mat-radio-button>
          <mat-form-field class="flex grow" subscriptSizing="dynamic">
            <mat-label>Date</mat-label>
            <input
              matInput
              formControlName="endingDate"
              [matDatepicker]="endingDate"
              (focus)="endingDate.open()"
              (click)="endingDate.open()"
            />
            <mat-datepicker-toggle matIconSuffix [for]="endingDate" />
            <mat-datepicker #endingDate />
          </mat-form-field>
        </div>

        <div class="flex flex-row items-center">
          <mat-radio-button class="w-36" value="after">After</mat-radio-button>
          <mat-form-field class="flex grow" subscriptSizing="dynamic">
            <input type="number" matInput formControlName="occurrenceCount" />
            <span matTextSuffix>{{ occurenceLabel }}</span>
          </mat-form-field>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <div *ngIf="showButtons">
    <button type="submit" mat-flat-button color="primary" (click)="submit()">
      Save
    </button>
  </div>
</form>
